import React from 'react';
import PokerCard from './PokerCard';
import { GAME_STATE, PLAYER_STATE } from '../constants/commonConstants';

// Table visibility must not depend on animation flags copied through effects.
// All card identities, turn states and animation endpoints use one snapshot.
const DeskDiscardCards = ({ roomData, playerId, positions, connectionReady, onPick }) => {
    if (!roomData || ![GAME_STATE.playing, GAME_STATE.winDeclared].includes(roomData.gameState)) return null;
    const players = roomData.players || [];
    const viewerIndex = Math.max(0, players.findIndex(player => player.playerId === playerId));
    const arranged = [...players.slice(viewerIndex), ...players.slice(0, viewerIndex)];
    const activeIndex = arranged.findIndex(player => [PLAYER_STATE.turnPick, PLAYER_STATE.pickedDeckCard,
        PLAYER_STATE.pickedDiscardedCard, PLAYER_STATE.declaredWin].includes(player.playerState));
    const active = arranged[activeIndex];
    const card = roomData.currentDiscardedCard;
    const ownerIndex = arranged.findIndex(player => player.discardedCards?.some(discarded => discarded.cardId === card?.cardId));
    const origin = positions[ownerIndex];
    const viewer = players.find(player => player.playerId === playerId);
    const pickable = viewer?.playerState === PLAYER_STATE.turnPick;
    const opening = roomData.isFirstTurn && roomData.upperShowedCard && !active?.pickedCards?.length;
    const picked = active?.playerState === PLAYER_STATE.pickedDiscardedCard ? active.pickedCards?.slice(-1)[0] : null;
    const animationStyle = targetLeft => ({
        '--origin-top': origin?.top || 'var(--desk-discard-top)',
        '--origin-left': origin?.left || 'var(--desk-discard-left)',
        '--target-top': 'var(--desk-discard-top)', '--target-left': targetLeft,
    });
    const discardClass = opening ? (pickable ? 'upper-showed-card-flash' : 'upper-showed-card')
        : (pickable ? 'flash-after-move' : 'noflash-after-move');
    return <div className="desk-animation-layer">
        {card && opening && <div key="opening-fold" className="card current-discarded-card upper-showed-card-fold" />}
        {picked && <div key={`picked:${picked.cardId}`} className="card current-discarded-card" style={{
            animation: 'moveDiscardedCardToPlayer 1s forwards',
            '--origin-top': 'var(--desk-discard-top)', '--origin-left': 'var(--desk-discard-left)',
            '--target-top': positions[activeIndex]?.top, '--target-left': positions[activeIndex]?.left,
        }}><PokerCard card={picked} isShowType /></div>}
        {card && !opening && roomData.isDiscardedPairCards &&
            <div key={`pair:${card.cardId}`} className={`card current-discarded-card ${discardClass}`}
                style={animationStyle('var(--desk-pair-left)')}><PokerCard card={card} isShowType /></div>}
        {card && <div key={`table:${card.cardId}:${Boolean(opening)}`} data-testid="desk-discard-card"
            className={`card current-discarded-card ${discardClass}`}
            style={opening ? undefined : animationStyle('var(--desk-discard-left)')}
            aria-disabled={!connectionReady} onClick={connectionReady ? onPick : undefined}>
            <PokerCard card={card} isShowType />
        </div>}
    </div>;
};

export default DeskDiscardCards;
